import React, { useState } from 'react';
import WebcamCapture from './components/WebcamCapture';
import ModelSelector from './components/ModelSelector';
import ImageUpload from './components/ImageUpload';
import VideoUpload from './components/VideoUpload';
import './App.css';

function App() {
  const [selectedModel, setSelectedModel] = useState('');
  const [activeTab, setActiveTab] = useState('webcam');

  return (
    <div className="App">
      <main className="app-main">
        <div className="header-bar">
          <div className="header-left">
            <h1 className="app-title">THỊ GIÁC MÁY TÍNH</h1>
            <p className="app-subtitle">Nhận diện realtime cho webcam, ảnh và video</p>
          </div>
          <div className="header-right">
            <ModelSelector selectedModel={selectedModel} onModelSelect={setSelectedModel} />
          </div>
        </div>

        <div className="tabs">
          <button
            className={`tab-btn ${activeTab === 'webcam' ? 'active' : ''}`}
            onClick={() => setActiveTab('webcam')}
          >
            📷 Webcam
          </button>
          <button
            className={`tab-btn ${activeTab === 'image' ? 'active' : ''}`}
            onClick={() => setActiveTab('image')}
          >
            🖼️ Hình ảnh
          </button>
          <button
            className={`tab-btn ${activeTab === 'video' ? 'active' : ''}`}
            onClick={() => setActiveTab('video')}
          >
            🎥 Video
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'webcam' && <WebcamCapture selectedModel={selectedModel} />}
          {activeTab === 'image' && <ImageUpload selectedModel={selectedModel} />}
          {activeTab === 'video' && <VideoUpload selectedModel={selectedModel} />}
        </div>
      </main>

      <footer className="app-footer">
        <div className="footer-content">
          <div className="connection-status">
            <span className="status-dot"></span>
            Kết nối AI Server (cv.ainnect.me)
          </div>
          <div className="footer-info">
            <p>Model: {selectedModel || 'Loading...'}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
